import { isRef } from '@vue/composition-api';
import { useActor } from './useActor';
export function getServiceSnapshot(service) {
    // TODO: remove compat lines in a new major, replace literal number with InterpreterStatus then as well
    return ('status' in service ? service.status : service._status) !== 0
        ? service.state
        : service.machine.initialState;
}
export function useService(service) {
    if (process.env.NODE_ENV !== 'production' &&
        !('machine' in (isRef(service) ? service.value : service))) {
        throw new Error("Attempted to use an actor-like object instead of a service in the useService() hook. Please use the useActor() hook instead.");
    }
    var _a = useActor(service, getServiceSnapshot), state = _a.state, send = _a.send;
    return { state: state, send: send };
}
